<template>
  <div class="curve_manag">
    <div class="flex_row">
      <el-input v-model="searchObj.curveNumber" :placeholder="$t('adminView.curveNumber')" clearable
        class="input-with-select" style="width: 250px; margin-right: 20px;" @change="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-input v-model="searchObj.descriptions" :placeholder="$t('adminView.descriptions')" clearable
        class="input-with-select" style="width: 250px; margin-right: 20px;" @change="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-input v-model="searchObj.manufacturer" :placeholder="$t('adminView.manufacturer')" clearable
        class="input-with-select" style="width: 250px; margin-right: 20px;" @change="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-input v-model="deviceModel" :placeholder="'机型'" clearable class="input-with-select"
        style="width: 250px; margin-right: 20px;" @change="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <div class="flex_end flex_one">
        <el-button type="primary" icon="el-icon-plus" @click="addCur" />
      </div>
    </div>
    <!-- 列表 -->
    <div v-loading="loading" style="position: relative;padding:10px 0 20px;width:100%;">
      <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}" border>
        <el-table-column prop="curveNumber" :label="$t('adminView.curveNumber')" align="center">
          <!-- <template slot-scope="scope">
            b{{ scope.row.curveNumber }}
          </template> -->
        </el-table-column>
        <el-table-column prop="descriptions" :label="$t('adminView.descriptions')" align="center" />
        <el-table-column prop="capacity" :label="$t('adminView.capacity')" align="center" />
        <el-table-column prop="battery" :label="$t('adminView.battery')" align="center" />
        <el-table-column prop="manufacturer" :label="$t('adminView.manufacturer')" align="center" />
        <el-table-column :label="'已录入机型'" align="center" >
          <template slot-scope="scope">
            {{ scope.row | handleModel }}
          </template>
        </el-table-column>
        <el-table-column :label="'创建时间'" align="center" >
          <template slot-scope="scope">
            {{ scope.row.createTime | timeFormat }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('yhubReport.Operating')" align="center">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <el-button type="primary" icon="el-icon-view " size="mini" @click="goToDetail(scope.row)" />
              <el-button type="primary" icon="el-icon-edit " size="mini" @click="editCur(scope.row, scope.$index)" />
              <el-button type="text" icon="el-icon-delete" size="mini" style="color: red;" @click="deleteCur(scope.row)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表模块————分页 -->
      <div class="pagination-container">
        <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
          :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop" width="80%"
      :title="isAdd? $t('adminView.add') : $t('adminView.Edit')">
      <save-curve v-if="isShowPop" @close="dialogClose" :row="dialogObj" :isAdd="isAdd" @nextRow="nextRow"></save-curve>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="showView" width="80%"
      :title="'查看'">
      <curve-detail :row="currentRow" v-if="showView"></curve-detail>
    </el-dialog>
  </div>
</template>

<script>
import { pagination } from '@/utils/init_table' // 分页
import { pageCurveNumberInfo, deleteCurve } from '@/api/settingBattery'
import SaveCurve from './SaveCurve.vue'
import CurveDetail from './curveDetail.vue'

export default {
  components: { SaveCurve, CurveDetail },
  data () {
     return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      tableData: [],
      searchObj: {},
      isShowPop: false,
      isAdd: true,
      dialogObj: {
        "id": "",
        "curveNumber": "",
        "descriptions": "",
        "capacity": "",
        "battery": "",
        "manufacturer": "",
        "g3024": "",
        "g3624": "",
        "g6024": "",
        "g1548": "",
        "g2548": "",
        "g3548": "",
        "g6048": "",
        "g2036": "",
        "g2536": "",
        "g3536": "",
        "g2572": "",
        "g4072": "",
        "g8080": "",
        "g10048": "",
        "g1524": "",
        "remark": "",
        "delFlag": "",
        "createTime": "",
        "g2036Dc": "",
        "g2536Dc": "",
        "g3536Dc": "",
        "g2572Dc": "",
        "g4072Dc": "",
        "g8080Dc": "",
        "g10048Dc": "",
        "g1524Dc": "",
        "g2548Dc": "",
        "g3548Dc": "",
        "g6048Dc": "",
        "g3024Dc": "",
        "g3624Dc": "",
        "g6024Dc": "",
        "g1548Dc": ""
      },
      loading: true,
      deviceModel: '',
      currentRow: {},
      showView: false,
      rowIndex: 0
    }
  },
  filters: {
    handleModel (item) {
      let m = []
      for (const key in item) {
        if (Object.prototype.hasOwnProperty.call(item, key)) {
          const val = item[key];
          if (key.indexOf('g') >= 0 && val && key.indexOf('Dc') < 0 && key != 'delFlag') {
            m.push(key.replace('g', ''))
          }
        }
      }
      return m.join(',')
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  mounted () {
    this.queryList()
  },
  methods: {
    dialogClose () {
      // this.queryList()
      this.isShowPop = false
    },
    queryList () {
      var param = {
        'curveNumber': this.searchObj.curveNumber,
        'descriptions': this.searchObj.descriptions,
        'manufacturer': this.searchObj.manufacturer,
        'pageNum': this.listQuery.pageInfo.pageNum,
        'pageSize': this.listQuery.pageInfo.pageSize,
        model: this.deviceModel
      }
      this.loading = true
      pageCurveNumberInfo(param).then(res => {
        console.log('曲线列表：', res)
        this.loading = false
        if (res.resultCode == 1001) {
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableData = res.resultModel.list
        }
      })
    },
    addCur () {
      for (var attr in this.dialogObj) this.dialogObj[attr] = ''
      console.log(this.dialogObj)
      this.isAdd = true
      this.isShowPop = true
    },
    deleteCur (row) {
      console.log(row)
      this.$confirm('此操作将永久删除该曲线, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmDelete(row)
      }).catch(() => {

      });
    },
    confirmDelete (row) {
      deleteCurve(row.id).then(res => {
        this.queryList()
        if (res.resultCode == 1001) {
          this.$message({
            message: '删除曲线成功',
            type: 'success'
          });
        }
      })
    },
    editCur (row, index) {
      this.dialogObj = row
      this.isAdd = false
      this.isShowPop = true
      this.rowIndex = index
    },
    nextRow () {
      this.isShowPop = false;
      setTimeout(() => {
        this.rowIndex++
        if (this.tableData[this.rowIndex]) {
          this.dialogObj = this.tableData[this.rowIndex]
          this.isShowPop = true;
        }
        
      }, 1000);
      
    },
    goToDetail (row) {
      this.showView = true;
      this.currentRow = row;
      // var routeData = this.$router.resolve({
      //   path: '/setting/curveDetail',
      //   query: {
      //     id: row.id
      //   }
      // })
      // window.open(routeData.href)
    },
    // 筛选改变事件
    changeSearch () {
      // 去掉首尾空格
      if (this.searchObj.curveNumber) this.searchObj.curveNumber = this.searchObj.curveNumber.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (this.searchObj.descriptions) this.searchObj.descriptions = this.searchObj.descriptions.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (this.searchObj.manufacturer) this.searchObj.manufacturer = this.searchObj.manufacturer.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')

      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    change (e) {
      this.$forceUpdate()
    },
    // 分页----startce
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>
<style lang="scss">
.curve_manag {
  background: #fff;
  padding: 20px;
}
</style>
